import { Badge } from '@chakra-ui/react'

/**
 * Badges
 */

export const PythonBadge = () => {
    return <Badge colorScheme={'blue'}>Python</Badge>
}

export const SolidworksBadge = () => {
    return <Badge colorScheme={'teal'}>Solidworks</Badge>
}

export const KiCadBadge = () => {
    return <Badge colorScheme={'green'}>KiCad</Badge>
}

export const ROSBadge = () => {
    return <Badge colorScheme={'blue'}>ROS</Badge>
}

export const EmbeddedBadge = () => {
    return <Badge colorScheme={'orange'}>Embedded</Badge>
}

export const GazeboBadge = () => {
    return <Badge colorScheme={'purple'}>Gazebo</Badge>
}

export const MLBadge = () => {
    return <Badge colorScheme={'orange'}>ML</Badge>
}

export const FFmpegBadge = () => {
    return <Badge colorScheme={'green'}>FFmpeg</Badge>
}

export const MiditonesBadge = () => {
    return <Badge colorScheme={'green'}>Miditones</Badge>
}